import { Check } from '#components/Check'
import { usePop } from '#hooks'
import { Button, Notice, PanelBody, Spinner } from '@wordpress/components'
import { useTranslation } from 'react-i18next'

export const ImagesAltText = ({ pop }) => {
  const { t } = useTranslation()
  const parser = new DOMParser()

  const { post, isError, isLoading, isValidating, mutate } = usePop(pop)

  if (isError) {
    return <Notice status="error">{isError}</Notice>
  }

  if (isLoading) {
    return <Spinner />
  }

  if (!post) {
    return null
  }

  const contentHTMLCollection = parser.parseFromString(
    post.content.rendered,
    'text/html'
  )

  const images = Array.from(contentHTMLCollection.images).filter(
    (image) => !image.alt
  )

  const onSubmit = (event) => {
    event.preventDefault()
    mutate()
  }

  return (
    <PanelBody
      title={t('sidebar.imagesalttext.title')}
      icon={isValidating ? <Spinner /> : <Check condition={!images?.length} />}
      initialOpen={images?.length > 0}
    >
      <p>
        {t(
          `sidebar.imagesalttext.intro.${images?.length > 0 ? 'full' : 'empty'}`
        )}
      </p>

      {images.length ? (
        <>
          <form>
            <ul>
              {images.map((image, index) => (
                <li key={index}>
                  <img alt="" src={image.src} />
                </li>
              ))}
            </ul>
            <Button onClick={onSubmit} variant="primary">
              {t('sidebar.imagesalttext.cta')}
            </Button>
          </form>
        </>
      ) : null}
    </PanelBody>
  )
}
